import React, { useEffect, useState } from 'react';
import './Step2.css';
import { ArrowLeft, ArrowUp } from '../../../assets/icons';
import { useMyContext } from '../../../context/global/Context';
import { useFetchCoverages, useFetchGoogleAnalytics } from '../../../hooks';
import HiringOptions from '../../HiringOptions/HiringOptions';
import Loading from '../../Loading/Loading';
import QuotationOptions from '../../QuotationOptions/QuotationOptions';
import { Button } from '../../basic';
import { scrollToInfo } from '../../../utils/functions';
import { ENV } from '../../../config/constants';
import { isEmpty } from '../../../utils/validation';

const Step2 = () => {
	const { functions: { handleStepQuotation, handlePotencialPolicy }, potencialPolicy, vehicleData, emitQuotationEnabled } = useMyContext();

	const { coverages, loadingCoverages } = useFetchCoverages();
	const { logViewItemList } = useFetchGoogleAnalytics(2);

	const [disabled, setDisabled] = useState(false);

	useEffect(() => {
		if (ENV === 'prod' && !isEmpty(vehicleData.Rama)) {
			const scriptUrl = `https://www.w4gb0ubgf.com/scripts/sdk/everflow.js`;

			const scriptPixel = document.createElement('script');
			scriptPixel.src = scriptUrl;
			scriptPixel.id = 'pixel_script_1';
			document.head.appendChild(scriptPixel);

			const scriptPixelFunc = document.createElement('script');
			scriptPixelFunc.innerHTML = `EF.click({
				offer_id: EF.urlParameter('oid'),
				affiliate_id: EF.urlParameter('affid'),
				source_id: EF.urlParameter('source_id'),
				sub1: EF.urlParameter('sub1'),
				sub2: EF.urlParameter('sub2'),
				sub3: EF.urlParameter('sub3'),
				sub4: EF.urlParameter('sub4'),
				sub5: EF.urlParameter('sub5'),
				uid: EF.urlParameter('uid'),
				transaction_id: EF.urlParameter('_ef_transaction_id'),
			});`;
			scriptPixelFunc.id = 'pixel_script_2';
			document.head.appendChild(scriptPixelFunc);

			const scriptPixelConv = document.createElement('script');
			scriptPixelConv.src = scriptUrl;
			scriptPixelConv.id = 'pixel_script_3';
			document.body.appendChild(scriptPixelConv);

			const scriptPixelConvFunc = document.createElement('script');
			scriptPixelConvFunc.innerHTML = `EF.conversion({
				offer_id: ${vehicleData.Rama === 3 ? '283' : '301'},
			});`;
			scriptPixelConvFunc.id = 'pixel_script_4';
			document.body.appendChild(scriptPixelConvFunc);

			return () => {
				document.getElementById('pixel_script_1').remove();
				document.getElementById('pixel_script_2').remove();
				document.getElementById('pixel_script_3').remove();
				document.getElementById('pixel_script_4').remove();
			}
		}
	}, [vehicleData]);

	useEffect(() => {
		if (loadingCoverages === false) {
			logViewItemList();
		}

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [loadingCoverages]);

	useEffect(() => {
		if (parseInt(emitQuotationEnabled) === 0)
			setDisabled(true);
		else {
			setDisabled(vehicleData.Vigency);
		}
	}, [vehicleData, emitQuotationEnabled]);

	const handleStepView = (step) => {
		handleStepQuotation(step);
	}

	const handleSelectedCoverage = (id) => {
		handlePotencialPolicy(coverages.find(e => e.coverageId === id));
	}

	return (
		<div className='step2'>
			{
				loadingCoverages ?
					<Loading />
					:
					<QuotationOptions coverages={coverages} selectedCoverage={potencialPolicy} setSelectedCoverage={handleSelectedCoverage} />
			}
			{
				disabled === false ?
					<HiringOptions />
					:
					<></>
			}
			<div className="flex flex-col-reverse md:flex-row mt-4 pt-1 w-full md:w-3/4 mx-auto justify-center px-6 md:px-0">
				<div className="flex w-full md:w-auto justify-center md:justify-start">
					<Button title="volver al paso anterior" className={`border-0 py-2 font-semibold text-base uppercase bg-white text-light-grey-disabled flex flex-row items-center ${disabled === false ? 'md:me-10' : ''}`} icon={<ArrowLeft size={23} color={'#A1AEB7'} className={'ms-4'} />} size={'auto'} handleClick={() => { handleStepView(1) }} disabled={false} />
				</div>
				{
					disabled === false ?
						<Button title="elegí tu plan" className={'uppercase bg-deep-pink text-white rounded-md py-2 mb-6 md:mb-0 hover:bg-opacity-85'} size={'full'} handleClick={() => { scrollToInfo() }} icon={<ArrowUp size={16} color='white' className='me-4' />} iconPosition={'start'} />
						:
						<></>
				}
			</div>
		</div>
	);
};

export default Step2;